import { Button, type ButtonProps } from '@chakra-ui/react';

/**
 * The affirmative action on a screen — submit, continue, confirm.
 *
 * Styling lives once, in the theme's button recipe under `visual.primary`, including the full-width
 * and vertical padding this shape has always defaulted to. The component exists so a usage is a
 * symbol rather than a string: find-references and rename work on it, which a `visual="primary"`
 * spelled at each call site cannot offer.
 */
const PrimaryButton = (props: ButtonProps) => <Button visual="primary" {...props} />;

export default PrimaryButton;
